export default "__VITE_ASSET__DBpyViUF__"